export const TRANSLATIONS_ES = {
    "select_language": "SELECCIONAR IDIOMA",
    "location": "Ubicación",
    "business": "Negocio",
    "region": "Región",
    "filter_by": "Filtrar por",
    "menu": "Menú",
    "favourites": "Favoritos",
    "you_do_not_have_any_favourites": "No tienes favoritos.",
    "favourites_message": "Las opciones favoritas aparecerán como selecciones predeterminadas cada vez que visite Logistics MAESTRO. Para marcar al cliente como favorito, simplemente haga clic en el icono favorito",
    "rows_per_page": "Filas por página",
    "no_records_to_display": "No hay registros que mostrar",
    "records": "Archivo",
    "loading": "Carga",
    "location_search": "Búsqueda de ubicación",
    "search": "Buscar",
    "locations": "Ubicaciones",
    "daily": "Diario",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "quarterly": "Trimestral",
    "Jan": "Ene",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Abr",
    "May": "May",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Ago",
    "Sep": "Sep",
    "Oct": "Oct",
    "Nov": "Nov",
    "Dec": "Dic",
    "exportVolume": "Volumen de exportación",
    "importVolume": "Volumen de importación",
    "exportOrder": "Detalles del pedido de exportación",
    "importOrder": "Detalles del pedido de importación",
    "lao_restricted": "La página a la que intentas acceder está restringida.\n Si desea solicitar un acceso, póngase en contacto con nuestro servicio de asistencia.",
    "lao_sites_failed": "Por el momento, no hemos podido procesar los datos relacionados con LAO.\n Intente actualizar la página después de un tiempo. Si aún así no ayuda, póngase en contacto con nuestro servicio de asistencia.",
    "views_loading_failed": "Error en la carga de vistas",
    "feedback": "Retroalimentación",
    "feedback_sucessfully_posted": "¡Comentarios publicados con éxito!",
    "something_went_wrong_please_try_again": "¡Algo salió mal!, por favor, inténtelo de nuevo",
    "send_us_feedback": "Envíenos sus comentarios",
    "thank_you_for_taking_the_time_to_give_us_feedback": "Gracias por tomarse el tiempo de darnos su opinión.",
    "are_you_satisfied_with_your_experience": "¿Está satisfecho con su experiencia?",
    "required": "Obligatorio",
    "submit_feedback": "Enviar comentarios",
    "tell_us_about_your_experience": "Cuéntanos tu experiencia",
    "network": "Red",
    "my_selections": "Mi Selección",
    "clear_selections": "Borrar selecciones",
    "save_selections": "Guardar selecciones",
    "view_more": "Ver más",
    "view_less": "Ver menos",
    "filters": "Filtros",
    "views": "Vistas",
    "add_view": "Agregar vista",
    "reset": "Restablecimiento",
    "new_view": "Nueva vista",
    "save": "Salvar",
    "delete": "Borrar",
    "new_view_name_msg": "Crea una nueva vista con la configuración predeterminada",
    "enter_a_view_name": "Introduzca un nombre de vista",
    "saved_successfully": "Guardado con éxito",
    "untitled_view": "Vista sin título",
    "created": "Creado",
    "deleted": "borrado",
    "filter_search": "BÚSQUEDA DE FILTROS",
    "clear_all": "Borrar todo",
    "select_all": "Seleccionar todo",
    "enter": "Entrar",
    "expand": "Expandir",
    "collapse": "Colapso",
    "all": "Todo",
    "manage_columns": "Administrar columnas",
    "show_all": "Mostrar todo",
    "hide_all": "Ocultar todo",
    "refresh": "Actualizar",
    "export": "Exportar",
    "apply_selections": "Aplicar selecciones",
    "more": "más",
    "loading_text": "Siéntese y relájese, mientras cargamos los datos para usted...",
    "we_are_sorry": "Lo sentimos...",
    "all_locations": "Todas las ubicaciones",
    "dot": "Ubicaciones Operadas por la Distribución",
    "nondot": "Ubicaciones no operadas por distribución",

    //LAO Table
    "purchase_order_origin": "PO",
    "order_#": "Order #",
    "order_type": "Tipo de pedido",
    "purchase_order_trade_PO": "PO FTZ#",
    "purchase_order_trade_SO": "SO FTZ/SO Virtual",
    "invoice_num": "Número de factura",
    "invoicing_date": "Fecha de facturación",
    "vendor_number": "Número de proveedor",
    "vendor_plant": "Planta de proveedores",
    "origin_plant": "Planta (Planta de origen)",
    "free_trade_destination_plant": "Código FTZ de la planta",
    "free_trade_destination_description": "Nombre de la zona franca de la planta",
    "ftz_invoice_number": "Número de factura FTZ",
    "ftz_invoicing_date": "Fecha de facturación de la zona franca",
    "destination_plant": "Código de cliente/Planta",
    "destination_description": "Nombre del cliente",
    "origin_port": "Puerto de origen",
    "international_shipper": "Remitente internacional",
    "booking_number": "Número de reserva",
    "shipment_number": "Número de envío de exportación",
    "load_number": "Número de carga",
    "delivery_number": "Número de entrega",
    "export_shipment_status": "Estado de exportación",
    "origin_country": "País de origen",
    "destination_country": "País de destino",
    "bill_lading": "Conocimiento de embarque",
    "bid_lane_number": "Número de carril BID",
    "lao_order_details_search_helper_text": "Ingrese PO#, SO#, factura#, carga#, entrega#.",
    "plant_ftz_code": "Código FTZ de la planta",
    "vendor_name_plant": "Nombre del proveedor/Planta (Planta de origen)",
    "customer_code_plant": "Código de cliente/Planta",
    "customer_name": "Nombre del cliente",
    "container_id": "Id. de contenedor",
    "sku_id": "SKU (Material)",
    "material_description": "Descripción del material",
    "material_type": "Tipo de material",
    "import_shipment_number": "Número de envío de importación",
    "vendor_name": "Nombre del proveedor",
    "import_pre_shipment_status": "Estado previo al envío",
    "import_post_shipment_status": "Estado posterior al envío",
    "import_destination_port": "Nombre del puerto de destino",
    "import_license_number": "Número de licencia de importación",
    "import_license_date": "Fecha de la licencia de importación",
    "delivery_date": "Fecha de entrega",
    "shipment_mode": "Modo de envío",
    "import_container_type": "Tipo de contenedor",
    "incoterms": "Incoterms",
    "export_shipment_etd_date": "KC ETD",
    "export_shipment_eta_date": "KC ETA",
    "export_kc_documental_cutoff_date": "Corte Documental",
    "import_etd_date": "KC ETD",
    "import_eta_date": "KC ETA",
    "import_id_date": "Fecha de identificación",
    "import_declaration": "Declaración de Importación",
    "import_customs_channel": "Canal de Aduanas",
    "import_free_period_end_date": "Fin del período gratuito",
    "import_kc_dock_time": "Hora del muelle de KC",
    "import_req_date_cont_at_plant": "Fecha de requerimiento: cont en planta",
    "import_time_of_arrival_in_plant": "Hora de llegada a la planta",
    "import_date_cont_at_plant": "Fecha de continencia en planta",
    "import_hour_cont_at_plant": "Hora de cont en planta",
    "import_transhipment_etd": "Transbordo ETD",
    "import_tentative_eta": "ETA tentativa",
    "import_tentative_etd": "ETD tentativo",
    "import_customs_leave": "Permiso de Aduana",
    "import_container_return_date": "Fecha de devolución del contenedor",
    "delivery_completion_ind": "Finalización de la entrega",
    "po_creation_date": "Fecha de creación de la orden de compra",
    "statistics_date": "Fecha de las estadísticas",
    "dates_deviation": "Desviación de fechas",
    "net_price": "Precio neto",
    "currency": "Divisa",
    "need_number": "Número de necesidad",
    "tax_indicator": "Indicador tributario",
    "confirmation_control_key": "Control de confirmación",
    "requisitioner": "Requisador",
    "virtual_plant_code": "Código de planta virtual",
    "virtual_plant_name": "Nombre de la planta virtual",

    "po_item": "Posición de orden de compra",
    "sku_material": "SKU/Material",
    "po_quantity": "Cantidad de orden de compra",
    "quantity_packed": "Cantidad embalada",
    "volume_packed": "Volumen empaquetado",
    "order_unit": "Unidad de pedido",

    "no_data_found": "No se han encontrado datos",
    "download_started_msg": "Se ha iniciado la descarga de archivos. Esto puede tardar un par de segundos.",
    "download_progress_msg": "La descarga de archivos ya está en curso",
    "export_view": "VISTA DE EXPORTACIÓN",
    "with_product_details": "CON DETALLES DEL PRODUCTO",
    "without_product_details": "SIN DETALLES DEL PRODUCTO",
    "with_managed_columns_and_filters_applied": "Con columnas y filtros administrados aplicados",
    "well_this_is_unexpected": "Bueno, esto es inesperado...",
    "please_wait": "Espera...",
    "download_successful": "¡Descarga exitosa!",
    "download_failed_msg": "¡Arrepentido! Error en la descarga del archivo. Por favor, inténtelo de nuevo.",
    "view_deleted_success": "Ver eliminado correctamente",
    "view_deleted_failed": "Error en la eliminación de la vista",
    "view_fav_unfav_success": "Ver éxito favorito/no favorito",
    "view_fav_unfav_failed": "Ver Favorito/No Favorito Fallido",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha final",
    "please_wait_while_the_data_is_loading": "Espere mientras se cargan los datos...",
    "view_created_updated_success": "Vista creada/actualizada correctamente",
    "view_creation_updation_failed": "Error en la creación/actualización de la vista",
    "list_of_favourited_selections": "Lista de selecciones favoritas",
    "business_unit": "Unidad de Negocio",
    "delivery_eta": "Entrega ETA",
    "atleast_one_business_unit_needs_to_selected": "Es necesario seleccionar al menos una unidad de negocio",
    "exportOrderMobile": "Exportar",
    "importOrderMobile": "Importación",
    "lao_order_details_search_helper_text_import": "Orden de compra#, # de factura, BL#, número de envío de importación.",
    "yes": "Sí",
    "no": "No",
    "po": "Orden de compra",
    "sto": "Pedido de venta",
    "helperTextWithSeparator": "Para la búsqueda múltiple, utilice solo el punto y coma como separador. Ej: 111; 222 La búsqueda de comodines (*) solo está habilitada para la búsqueda única. Ej: 111* o 222*",
    "helperText": "Para la búsqueda múltiple, utilice separadores como coma, espacio o punto y coma. Ej: 111.222 o 111 222 o 111; 222 La búsqueda de comodines (*) solo está habilitada para la búsqueda única. Ej: 111* o 222*",
    "dest_plant": "Planta de destino",
    "storage_location": "Ubicación de almacenamiento",
    "item_desc": "Descripción del artículo",
    "pallets_qty": "Cantidad de palets",
    "volume_qty": "Cantidad de volumen",
    "availability_date": "Disponible el:",
    "exportDRPDetails": "Exportar detalles de DRP",
    "exportLoadPlanDetails": "Exportar detalles del plan de carga",
    "priority": "Prioridad",
    "sku": "SKU",
    "volume_v3": "Volumen (V3)",
    "description": "Descripción",
    "plant_origin": "Planta de origen",
    "quantity": "Cantidad",
    "fourkites_stage1": "FourKites Fase 1",
    "fourkites_stage2": "FourKites Fase 2",
    "fourkites_stage3": "FourKites Fase 3",

    // LAO Hamburger
    "close_menu": "Cerrar menú",
    "home": "Hogar",
    "export_planning": "Planificación de exportaciones",
    "kpi": "KPI",

    // Export Planning - Chart
    "exportDRP": "Exportación de DRP",
    "exportLoadPlan": "Plan de carga de exportación",
    "exportDRPMobile": "DRP",
    "exportLoadPlanMobile": "Plan de carga",
    "cases": "Casos",
    "volume": "Volumen",
    "pallets": "Paletas",
    "containers": "Recipientes",

    // Export Planning - Table
    "cubication_id": "Id. de cubicación",
    "id_position": "Posición de ID",
    "cubic_quantity": "Cantidad cúbica",
    "volume_m3": "Volumen (m3)",
    "gross_weight": "Peso bruto",
    "total_value": "Valor total",
    "container": "Contenedor",
    "cnt_type": "Tipo CNT",
    "customer_code": "Código de cliente",
    "po_so_export": "Exportación PO/SO",
    "po_so_ftz": "PO/SO FTZ",
    "shipping_line": "Línea Naviera",
    "cutt_of_documental": "Cortt De Documental",
    "etd": "ETD",
    "eta": "ETA",
    "lane_number": "Número de carril",
    "invoice": "Factura",
    "invoice_quantity": "Cantidad de la factura",
    "weight_unit": "Unidad de peso",
    "mode": "Modo",
    "load_date": "Fecha de carga",
    "carrier": "Portador",
    "comments": "Comentarios",
    "delivery": "Entrega",
    "import_KPI": "KPI de importación",
    "export_KPI": "KPI de exportación",

    // Import KPI 
    "forecast": "Previsión y predicción de contenedores",
    "po_line_items_by_shipment": "Artículos de línea de pedido por envío",
    "containers_ready_to_deliver": "Contenedores listos para entregar",
    "po_items_ct_with_shipment": "Con envío",
    "po_items_ct_without_shipment": "Sin envío",
    "containers_with_import_declaration": "Contenedores con Declaración de Importación",
    "containers_with_import_declaration_mobile": "Contenedores con ID",
    "containers_without_GR": "Contenedores sin GR",
    "with_GR": "Con GR",
    "without_GR": "Sin GR",
    "without_GR_with_RDD": "Con fecha de solicitud",
    "without_GR_without_RDD": "Sin fecha de solicitud",
    "goods_received": "Bienes recibidos",
    "gr_date": "GR Fecha",
    "plant_ftz": "Planta FTZ",
    "invoice_date": "Fecha de la factura",
    "international_declaration_date": "Fecha de la Declaración Internacional",
    "total": "Total",
    "containers_by_requested_delivery_date_at_plant": "Contenedores por fecha de entrega solicitada en planta",
    "total_shipments": "Envíos totales",
    "shipment_containers": "Contenedores de envío",
    "total_containers": "Recipientes",
    "containers_without_import_declaration": "Contenedores sin declaración de importación",
    "kpi_destination": "En destino",
    "pending_for_arrival": "Pendiente de llegada",
    "with_import_declaration": "Con Declaración de Importación",
    "without_import_declaration": "Sin declaración de importación",
    "carrier_operations": "Operaciones de transportistas (top 10)",

    "po_items_by_deviation": "Posiciones de pedido por desviación",
    "po_item_with_deviation": "PO'S - artículo con desviación",
    "po_item_without_deviation": "PO'S - artículo sin desviación",
    "po_with_deviation": "%de órdenes de compra con desviación",

    "contract_percentage": "Porcentaje de contrato",
    "import_kpi_shipment": "Envío",
    "import_kpi_container": "Contenedor",
    "bid": "Oferta",
    "spot": "Mancha",
    "live_status_text": "ESTADO EN VIVO",
    "goods_completion": "Finalización de GR",
    "cntrWithGR": "Contenedores recibidos",
    "cntrWithoutGR": "Contenedores de importación",

    // Import KPI filter chips
    "searchSubType": "Tipo de búsqueda",
    "import_kpi_po_items_shipment": "Artículos de correos con envío",
    "import_kpi_po_items_without_shipment": "Artículos postales sin envío",

    "import_kpi_shipment_containers": "Contenedores de envío",
    "import_kpi_shipment_containers_id": "Contenedores de envío con declaración de importación",
    "import_kpi_shipment_containers_without_id": "Contenedores de envío sin declaración de importación",
    "import_kpi_shipment_containers_without_id_at_dest": "Contenedores de envío sin declaración de importación en el destino",
    "import_kpi_shipment_containers_without_id_pending": "Contenedores de envío sin declaración de importación pendientes de llegada",

    "import_kpi_container_rtd_with_gr": "Contenedores con RG",
    "import_kpi_container_rtd_without_gr": "Contenedores sin RG",
    "import_kpi_container_rtd_with_gr_with_rd": "Contenedores con RG y con RDD",
    "import_kpi_container_rtd_without_gr_with_rd": "Contenedores sin RG y con RDD",
    "import_kpi_container_rtd_without_gr_without_rd": "Contenedores sin GR y sin RDD",

    "import_kpi_container_rdd": "Contenedores por fecha de entrega solicitada en la planta",

    "import_kpi_po_items_deviation": "Oficiales de libertad condicional con desviación",
    "import_kpi_po_items_without_deviation": "Puntos de Libertad Oficial sin Desviación",
    "import_kpi_po_items_with_deviation": "%PO con desviación",

    "import_kpi_carrier_op_container_spot": "Spot de Contenedores de Operaciones de Portaaviones",
    "import_kpi_carrier_op_container_bid": "Oferta de contenedores de operaciones de transportistas",
    "import_kpi_carrier_op_shipment_spot": "Operaciones de Transporte Spot de Envío",
    "import_kpi_carrier_op_shipment_bid": "Oferta de envío de operaciones de transportistas",

    "import_kpi_carrier_contract_container_spot": "Porcentaje de contrato Spot de contenedores",
    "import_kpi_carrier_contract_container_bid": "Porcentaje de contrato Oferta de contenedor",
    "import_kpi_carrier_contract_shipment_spot": "Porcentaje de Contrato Spot de Envío",
    "import_kpi_carrier_contract_shipment_bid": "Porcentaje de Contrato Oferta de Envío",

    "import_container_forecast": "Previsión de contenedores de importación",

    //Export KPI
    "export_line_items_planned": "Exportar partidas individuales planificadas",
    "po_items_with_ld_nbr": "Con número de carga",
    "po_items_without_ld_nbr": "Sin número de carga",
    "export_units_invoiced_by_last_6_months": "Exportar unidades facturadas por los últimos 6 meses",
    "export_units_by_carrier": "Exportar unidades por transportista",
    "export_units_by_status": "% de unidades de exportación por estado",
    "total_count": "Recuento total",
    "export_units_by_shipment_mode": "Exportar unidades por modo de envío",
    "ocean": "Océano",
    "land": "Tierra",
    "air": "Aire",
    "transport_by_shipment_mode": "% Transporte por modo de envío",
    "export_units_containers_trucks": "Unidades de exportación (contenedores/camiones)",
    "exports_unit": "Unidad de Exportaciones",
    "billing_pending": "Facturación pendiente",
    "export_line_items_with_load_number": "Exportar partidas individuales con número de carga",
    "exports_unit_with_shipment": "Unidad de exportación con envío",
    "exports_unit_invoiced": "Unidad de exportaciones facturada",
    "lds_invoiced_with_shipment": "Facturado con envío",
    "lds_invoiced_without_shipment": "Facturado sin envío",

    // Export KPI filter chips
    "export_kpi_line_items_with_ld": "Partidas de línea con número de carga",
    "export_kpi_line_items_without_ld": "Elementos de línea sin número de carga",
    "export_kpi_export_units_total": "Total de unidades de exportación",
    "export_kpi_export_units_invoiced": "Unidades de exportación facturadas",
    "export_kpi_export_units_billing_pending": "Facturación de unidades de exportación pendiente",
    "export_kpi_units_with_shipment": "Unidades de exportación con envío",
    "export_kpi_units_without_shipment": "Unidades de exportación sin envío",
    "export_kpi_units_by_month": "Unidades de exportación por mes",
    "export_kpi_units_mode_ocean": "Unidades de exportación por Modo de Envío Océano",
    "export_kpi_units_mode_land": "Unidades de exportación por Modo de Envío Terrestre",
    "export_kpi_units_mode_air": "Unidades de exportación por modo de envío aéreo",
    "export_kpi_carrier": "Unidades de exportación por transportista",
    "export_kpi_carrier_bid": "Unidades de exportación por estatus de portaaviones y oferta",
    "export_kpi_carrier_spot": "Unidades de exportación por estado de portaaviones",

    // Timeline KPI
    "timeline_KPI": "KPI de línea de tiempo",
    "po_so_items": "Artículos de pedido / so",
    "shipments": "Envíos",
    "export_vendors": "Proveedores de exportación",
    "intercompany": "Intercompañía",
    "direct_shipment": "Envío directo",
    "in_production_and_dispatch": "En producción y expedición",
    "in_load_planning": "En la planificación de la carga",
    "billed_and_charged": "Facturado y cobrado",
    "confirmed_itinerary": "Itinerario confirmado",
    "in_international_transit": "En tránsito internacional",
    "in_customs_process_at_destination": "En proceso aduanero en destino",
    "nationalized_pending_placement_request": "Solicitud de colocación pendiente nacionalizada",
    "nationalized_with_placement_date": "Nacionalizado con fecha de colocación",
    "available": "Disponible",
    "qty": "Qty",
    "p%": "P%",

    // Leadtime KPI
    "leadtime_KPI": "KPI de tiempo de entrega",
    "process_type": "Tipo de proceso",
    "leadtime_shipment_etd_date": "KC ETD",
    "leadtime_shipment_eta_date": "KC ETA",
    "leadtime_shipment_id_date": "Fecha de identificación",
    "incoterm": "Incoterm",
    "lead_time_by_month_and_year": "Plazos de entrega por mes y año",
    "lead_time_by_origin_country": "Tiempo de entrega por país de origen",
    "avg_international_transit_by_shipper": "Tránsito internacional medio por remitente",
    "international": "Internacional",
    "origin": "Origen",
    "destination": "Destino",
    "min": "Min",
    "max": "Max",
    "avg": "Promedio",
    "previous_dest": "Destino",
    "previous_international": "Internacional",
    "previous_origin": "Origen",
    "current_dest": "Destino",
    "current_international": "Internacional",
    "current_origin": "Origen",
    "previous": "Anterior",
    "current": "Actualidad",
    "intl": "Internacional",
    "org": "Org",
    "destMobile": "Dest",
    "tot": "Tot",
    "shipment_num": "Número de envío",
    "customer": "Cliente",
    "maritime_m": "Marítimo (M)",
    "external_vendor_ev": "Proveedor externo (EV)",
    "intercompany_ic": "Intercompañía (IC)",
    "direct_shipment_ds": "Envío directo (DS)",
    "land_t": "Tierra (T)",
    "air_a": "Aire (A)",

    // Chat bot
    "chatInitialMessage": "¡Hola! ¿Cómo puedo ayudarle?",
    "chatErrorMessage": "Tuvimos un atasco temporal y no pudimos completar tu solicitud. Por favor, inténtalo de nuevo en unos minutos. Si el problema continúa, avísanos seleccionando el botón de pulgar abajo que aparece abajo.",
    "understanding_feasibility": "Comprendiendo la viabilidad",
    "extracting_contextual_intent": "Extracción de la intención contextual",
    "generating_instructions": "Generación de instrucciones",
    "constructing_query_explanation": "Construcción de la explicación de la consulta",
    "final_answer": "Generación de la respuesta final",
    "processing": "Procesamiento",
    "chat_btn_text": "Charla con LISA",
    "bar": "Barra",
    "line": "Línea",
    "pie": "Pastel",
    "combo": "Combo",
    "view_in_chart": "Ver en el gráfico",
    "chat_message_intro": "Hola, soy LISA, tu compañera con IA en Maestro.",
    "chat_message_user_manual": "para revisar el manual de usuario y ver el vídeo corto para aprender más sobre cómo usar LISA y hacer preguntas de forma eficaz.",
    "click_here": "Haz clic aquí",
    "lisa_auth_failed": "Parece que ahora mismo no tienes acceso a LISA.",
    "question": "Pregunta",
    "response": "Respuesta",
    "ai_accuracy_disclaimer": "Respuesta generada por IA. Comprueba la precisión.",
    "retrieval_details": "Detalles de la recuperación",
    "how_i_understand_your_question": "Cómo entendí tu pregunta",
    "calculations": "Cálculos",
    "filters_applied": "Filtros aplicados",
    "please_write_feedback": "Por favor, escribe tus comentarios.",
    "mention_what_didnt_go_right": "Menciona lo que no salió como esperaba.",
    "optional": "Opcional",
    "submit": "Enviar",
    "remove": "Eliminar",
    "like": "Como",
    "unlike": "A diferencia de",
    "ai_request_cancelled": "Solicitud cancelada",
    "stop": "¡Para",
    "copy": "Copiado",
    "edit": "Edición",
    "resend": "Reenviar",
    "seconds": "Segundos",
    "your_download_will_begin_shortly": "Tu descarga comenzará en breve",
    "preview_to_lisa": "Avance de LISA",
    "type_your_message": "Escribe tu mensaje",
    "question_interpreted_as": "Pregunta interpretada como",
    "record": "Historial",
    "export_without_chart": "Exportación sin Gráfico",
    "export_with_chart": "Exportación con lista",
    "close_window": "Cerrar ventana",

    // Alert Functionality
    "evaluate": "Evalúa",
    "save_alert": "Alerta de guardado",
    "add": "Añadir",
    "another": "Otro",
    "select_a_filter": "Seleccionar un filtro",
    "select_filters": "Seleccionar filtros",
    "you_can_only_select_00_or_30_in_minutes": "Solo puedes seleccionar 00 o 30 en minutos",
    "every_15_mins": "Cada 15 minutos",
    "every_30_mins": "Cada 30 minutos",
    "every_1_hour": "Cada 1 hora",
    "custom": "Costumbres",
    "enter_alert_name": "Introduce el nombre de la alerta",
    "update": "Actualización",
    "create_new": "Crear nuevo",
    "new_alert": "Nueva alerta",
    "create": "Crear",
    "alert": "Alerta",
    "create_new_alert": "Crear una nueva alerta",
    "alerts": "Alertas",
    "go_back_to_editing": "Volver a la edición",
    "criteria": "Criterios",
    "select_customer_or_sales_office": "Oficina de Clientes/Ventas Seleccionada",
    "minutes": "Actas",
    "days": "Días",
    "select_duration_unit": "Unidad de duración seleccionada",
    "select_comparison_field": "Seleccionar campo de comparación",
    "no_saved_alerts_found": "¡No se han encontrado alertas guardadas!",
    "saved_alerts": "Alertas guardadas",
    "ct_saved_alerts": "CT - Alertas guardadas",
    "high": "Alto",
    "medium": "Medio",
    "low": "Bajo",
    "alert_saved_successfully": "Alerta guardada con éxito",
    "please_validate_alert_and_try_again": "¡Por favor, valida la alerta y vuelve a intentarlo!",
    "enter_valid_email_ids": "Introduce los identificadores de correo electrónico válidos",
    "customers": "CLIENTES",
    "severity_of_alert": "Gravedad de la alerta",
    "frequency_of_alert": "Frecuencia de alerta",
    "send_alerts_to": "Envía alertas a",
    "alert_created_by": "Alerta creada por",
    "send_alerts_when": "Envía alertas cuando",
    "select_field": "Seleccionar campo",
    "select_comparison": "Selección de comparación",
    "comparison": "Comparación",
    "comparison_with": "Comparación con",
    "additional_time": "Tiempo adicional"

}